export enum PaymentMethod {
    DirectPayment,
    CreditNote
}